import {PdsWidget} from './pds-widget';
import {Wizard} from './models/wizard';
import { serviceInstances } from './services/service-instances';
import {Subscription} from 'rxjs';
import {WizardStep} from './interfaces/wizard-step';
import { pdsLogger } from './pds-logger';
import { pdsI18n } from './pds-i18n';
let log = pdsLogger.prependLogger(pdsLogger.requiresLogger('wizard'), 'pds-wizard-steps.ts');

export class PdsWizardSteps extends PdsWidget {

  is = 'pds-wizard-steps';

  dataWizardId: string | null;
  wizard: Wizard | undefined;

  wizardStreamSubscription: Subscription | undefined;

  wizardSteps: Array<WizardStep> | null;

  properties = {
    dataWizardId: {
      type: String,
      value: null,
      observer: 'updateWizard'
    },
    wizardSteps: { //TODO: Make this a private variable
      value: null
    }
  };

  updateWizard(): void {
    log('updateWizard() called');

    if (this.wizardStreamSubscription != null) {
      this.wizardStreamSubscription.unsubscribe();
      delete this.wizard;
    }

    if (this.dataWizardId == null) {
      return;
    }

    this.wizard = serviceInstances.getWizardService().getWizard(this.dataWizardId);
    log('using wizardId: ' + this.dataWizardId);

    this.wizardStreamSubscription = this.wizard.changeStream.subscribe((changedWizardSteps: Array<WizardStep>) => {
      if (this.wizard == null) {
        return;
      }
      log('wizard steps changed');
      this.wizardSteps = this.wizard.steps.values() || null;
      for (let step of changedWizardSteps) {
        this.redrawArray('wizardSteps', step);
      }
    });
    this.wizardSteps = this.wizard.steps.values() || null;
  }

  stepClickHandler(event: Event): void {
    log('stepClickHandler() called');
    if (this.wizard == null) {
      return;
    }

    let stepId: string | undefined = this.extractAttribute(event, 'button', 'id');
    if (stepId == null) {
      return;
    }
    log('stepId clicked: ' + stepId);
    let step: WizardStep | undefined = this.wizard.steps.get(stepId);
    if (step == null || step.isDisabled) {
      return;
    }
    this.wizard.setActiveStep(stepId);
  }

  isShowCompleteIcon(step: WizardStep): boolean {
    return step.isComplete === true && step.isActive !== true;
  }

  isShowActiveIcon(step: WizardStep): boolean {
    return step.isActive === true;
  }

  isShowNormalIcon(step: WizardStep): boolean {
    return step.isComplete !== true && step.isActive !== true;
  }

  getWizardStepAriaLabel(step: WizardStep): string {
    if (step.isActive) {
      return step.text + ' - ' + pdsI18n.getText('pds|wizard|Current Step');
    }

    if (step.isComplete) {
      return step.text + ' - ' + pdsI18n.getText('pds|wizard|Completed');
    }

    return step.text + ' - ' + pdsI18n.getText('pds|wizard|Incomplete Step');
  }

  getCurrentStepAria(step: WizardStep): string | null {
    if (step.isActive) {
      return pdsI18n.getText('pds|wizard|step');
    } else {
      return null;
    }
  }
}
